import { useCallback, useContext } from 'react'
import { BffAuthContext } from './features/bff-auth/BffAuthContext'
import { performManualSignOut } from './performManualSignOut'

type PerformManualSignOutOptions = Parameters<typeof performManualSignOut>[0]

export function useSignOut(): (options?: PerformManualSignOutOptions) => Promise<void> {
    const bffAuth = useContext(BffAuthContext)

    return useCallback(
        async (options?: PerformManualSignOutOptions) => {
            if (bffAuth) {
                await bffAuth.signOut()
                return
            }

            await performManualSignOut(options)
        },
        [bffAuth],
    )
}
